export const Colors = {
  Primary: '#CE1126',
  Black: '#333',
  'Grey/VeryDark': '#212121',
  'Grey/VeryLight': '#C2C2C2',
  'Grey/Light': '#D9D9D9',
  Grey: '#888',
  White: '#FFFFFF',
  Green: '#1FC600',
  Red: '#CE1126',
  'Red/VeryLight': '#f8abb4',
};
